import { Injectable } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Injectable({
  providedIn: 'root',
})
export class VideoEmbedUtils {
  constructor(private sanitizer: DomSanitizer) {}

  public getVideoEmbedFromUrl(link: string): SafeHtml {
    if (!link) return '';
    const YOUTUBE_LINK_MATCH = 'https://www.youtube.com/watch';
    const YOUTUBE_EMBED_MATCH = 'https://www.youtube.com/embed';
    const YOUTUBE_EMBED = 'https://www.youtube-nocookie.com/embed';
    const YOUTUBE_LINK_SHORT = 'https://youtu.be';
    const VIMEO_LINK_MATCH = 'https://vimeo.com';
    const VIMEO_EMBED = 'https://player.vimeo.com/video';

    if (link.indexOf(YOUTUBE_LINK_MATCH) >= 0) {
      const url = new URL(link);
      const param = url.searchParams.get('v');
      return this.youtubeEmbedTemplate(`${YOUTUBE_EMBED}/${param}`);
    } else if (link.indexOf(YOUTUBE_EMBED_MATCH) >= 0) {
      return this.youtubeEmbedTemplate(link);
    } else if (link.indexOf(YOUTUBE_LINK_SHORT) >= 0) {
      const splitURL = link.split('/');
      const id = splitURL[splitURL.length - 1];
      return this.youtubeEmbedTemplate(`${YOUTUBE_EMBED}/${id}`);
    } else if (link.indexOf(VIMEO_LINK_MATCH) >= 0) {
      const splitURL = link.split('/');
      const id = splitURL[splitURL.length - 1];
      return this.vimeoEmbedTemplate(`${VIMEO_EMBED}/${id}`);
    }
  }

  private vimeoEmbedTemplate(url: string) {
    const html = `<iframe width="560" height="315" src="${url}" title="Vimeo video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>`;
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  private youtubeEmbedTemplate(url: string) {
    const html = `<iframe width="560" height="315" src="${url}?controls=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>`;
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
